var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"travel-quote-info"},[_c('h2',[_vm._v("Policy Detail")]),_c('pet-quote-info',{attrs:{"formData":_vm.formData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }